import { render } from "./Impressum.vue?vue&type=template&id=5db6f7c9&scoped=true&bindings={}"
import script from "./Impressum.vue?vue&type=script&lang=js"
export * from "./Impressum.vue?vue&type=script&lang=js"

import "./Impressum.vue?vue&type=style&index=0&id=5db6f7c9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5db6f7c9"

export default script